import { map } from 'rxjs/operators/map';
import ajax from '../../utils/ajax';
import { SiteSerializer } from '../../models';


function sortName(s1,s2){
  return s1.value.localeCompare(
    s2.value,
    'en-US',
    { numeric: true, sensitivity: 'base' }
  );
}

class SiteService {
  conductorUrl = process.env.REACT_APP_CONDUCTOR_ASSETS_URL || '';
  configurationPathGroup = '/networkAsset/airfinder/sites';
  configurationPath = '/networkAsset/airfinder/site';

  /**
    Create a Site
    @param {Object} Site
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  create = (site, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPathGroup}`,
        body: SiteSerializer.serialize(site),
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        responseType: 'json'
      },
      store
    ).pipe(map(data => SiteSerializer.normalize(data.response)));
  };
 
  /**
    Delete a Site
    @param {String} siteId
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  delete = (siteId, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPath}/${siteId}`,
        body: '',
        headers: { 'Content-Type': 'application/json' },
        method: 'DELETE',
        responseType: 'json'
      },
      store
    );
  };

  /**
    Edit a Site
    @param {Object} Site
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  edit = (site, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPath}/${site.id}`,
        body: SiteSerializer.serializeEdit(site),
        headers: { 'Content-Type': 'application/json' },
        method: 'PUT',
        responseType: 'json'
      },
      store
    ).pipe(map(data => SiteSerializer.normalize(data.response)));
  };

  /**
    Edit a Site's Labels
    @param {Object} Site
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  editLabels = (site, orgId, store) => {
    let url=`${this.conductorUrl}${this.configurationPath}/${site.id}`
    if(orgId){
      url=`${url}?organizationId=${orgId}`;
    }
    return ajax(
      {
        url,
        body: SiteSerializer.serializeLabels(site),
        headers: { 'Content-Type': 'application/json' },
        method: 'PUT',
        responseType: 'json'
      },
      store
    ).pipe(map(data => SiteSerializer.normalize(data.response)));
  };

  /**
    Get all sites from an Account
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized list of sites
  */
  getAll = (store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${
          this.configurationPathGroup
        }?currentUser=true`,
        method: 'GET',
        responseType: 'json'
      },
      store
    ).pipe(map(data => data.response.sort(sortName).map(SiteSerializer.normalize)));
  };
  
  // get the site user
  getSiteUser = (store, siteId) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPath}/${siteId}/user`,
        body: '',
        headers: { 'Content-Type': 'application/json' },
        method: 'GET',
        responseType: 'json'
      },
      store
    )
  }
}

export default new SiteService();



// WEBPACK FOOTER //
// ./src/services/site/index.js